var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentLoading || _vm.forceOn)?_c('span',[_c('intersect',{on:{"leave":function($event){return _vm.leaveView()}}},[_c('progress',{staticClass:"progress oto-progress-bar is-primary sticky-loading",class:{ 'force-top': _vm.forceTop },attrs:{"id":"progress","max":"100"}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }